import { INDISPENSABLE_SUBCATEGORY, IndispensableProduct, PRODUCT_CATEGORY } from '~/models/Product'
import revolutCover from '~/assets/trip/store/indispensables/revolutCover.jpg'
import discoverCarsCover from '~/assets/trip/store/indispensables/discoverCarsCover.png'
import heymondoCover from '~/assets/trip/store/indispensables/heymondoCover.png'
import holaflyCover from '~/assets/trip/store/indispensables/holaflyCover.png'
import intermundialCover from '~/assets/trip/store/indispensables/intermundialCover.png'
import ivisaCover from '~/assets/trip/store/indispensables/ivisaCover.png'
import revolut from '~/assets/trip/store/indispensables/revolut.png'
import discoverCars from '~/assets/trip/store/indispensables/discoverCars.png'
import heymondo from '~/assets/trip/store/indispensables/heymondo.png'
import holafly from '~/assets/trip/store/indispensables/holafly.png'
import intermundial from '~/assets/trip/store/indispensables/intermundial.png'
import ivisa from '~/assets/trip/store/indispensables/ivisa.png'
import { TranslationService } from '../Translation'

export class ProductRepository {
	static getIndispensables(standardizedCountryName: string): IndispensableProduct[] {
		const intermundialCountries = ['spain', 'portugal', 'italy']
		const showIntermundial = intermundialCountries.includes(standardizedCountryName)
		const translation = TranslationService.getInstance()
		const locale = translation.getLocale()
		const intermundialUrlsByLang: Record<string, string> = {
			es: 'https://www.intermundial.es/afiliados/seguros-de-viaje-recomendado?utm_source=Affiliates&utm_medium=Affiliates&utm_campaign=General&utm_term=67a2405de05f4&utm_content=67a2405de05f41',
			pt: 'https://www.intermundial.pt/afiliados/seguro-de-viagem-recomendado?utm_source=Affiliates&utm_medium=Affiliates&utm_campaign=General&utm_term=67a2405de05f4&utm_content=67a2405de05f41',
			it: 'https://www.intermundial.it/affiliates/assicurazione-viaggio?utm_source=Affiliates&utm_medium=Affiliates&utm_campaign=General&utm_term=67a2405de05f4&utm_content=67a2405de05f4',
		}
		const insuranceProduct: IndispensableProduct = showIntermundial
			? {
					id: '4',
					title: translation.translate('web.essential.intermundial.hook'),
					category: PRODUCT_CATEGORY.INDISPENSABLE,
					subcategory: INDISPENSABLE_SUBCATEGORY.INSURANCE,
					coverUrls: [intermundialCover],
					url: intermundialUrlsByLang[locale] || intermundialUrlsByLang['es'],
					data: {
						providerImage: intermundial,
					},
				}
			: {
					id: '5',
					title: translation.translate('web.essential.heymondo.hook'),
					category: PRODUCT_CATEGORY.INDISPENSABLE,
					subcategory: INDISPENSABLE_SUBCATEGORY.INSURANCE,
					coverUrls: [heymondoCover],
					url: 'https://heymondo.es/?utm_medium=Afiliado&utm_source=PASSPORTER&utm_campaign=PRINCIPAL&cod_descuento=PASSPORTER&ag_campaign=ENTRADA&agencia=TmQ6oVUdKUtb48XOjACNv0Y0djarI5oI6wsdlQr5',
					data: {
						providerImage: heymondo,
					},
				}

		return [
			{
				id: '1',
				title: translation.translate('web.essential.revolut.hook1'),
				category: PRODUCT_CATEGORY.INDISPENSABLE,
				subcategory: INDISPENSABLE_SUBCATEGORY.BANK,
				coverUrls: [revolutCover],
				url: locale === 'es' ? 'https://revolut.ngih.net/4arW4n' : 'http://revolut.ngih.net/X41oxg',
				data: {
					providerImage: revolut,
					hasTermsAndConditions: true,
				},
			},
			{
				id: '2',
				title: translation.translate('web.essential.revolut.hook2'),
				category: PRODUCT_CATEGORY.INDISPENSABLE,
				subcategory: INDISPENSABLE_SUBCATEGORY.BANK,
				coverUrls: [revolutCover],
				url: locale === 'es' ? 'http://revolut.ngih.net/enRJKO' : 'https://revolut.ngih.net/NGzO47',
				data: {
					providerImage: revolut,
					hasTermsAndConditions: true,
				},
			},
			{
				id: '3',
				title: translation.translate('web.essential.holafly.hook'),
				category: PRODUCT_CATEGORY.INDISPENSABLE,
				subcategory: INDISPENSABLE_SUBCATEGORY.SIM,
				coverUrls: [holaflyCover],
				url: 'http://holafly.sjv.io/vD205d',
				data: {
					providerImage: holafly,
				},
			},
			insuranceProduct,
			{
				id: '6',
				title: translation.translate('web.essential.ivisa.hook'),
				category: PRODUCT_CATEGORY.INDISPENSABLE,
				subcategory: INDISPENSABLE_SUBCATEGORY.VISA,
				coverUrls: [ivisaCover],
				url: 'https://www.ivisa.com/?utm_source=passporterapp',
				data: {
					providerImage: ivisa,
				},
			},
			{
				id: '7',
				title: translation.translate('web.essential.discovercars.hook'),
				category: PRODUCT_CATEGORY.INDISPENSABLE,
				subcategory: INDISPENSABLE_SUBCATEGORY.RENTAL,
				coverUrls: [discoverCarsCover],
				url: 'https://www.discovercars.com/?a_aid=passporterapp',
				data: {
					providerImage: discoverCars,
				},
			},
		]
	}
}
